import { getCookie } from "./clickAndCollect"

export const getCookieValueFromConsent = (key: string): boolean => {
  try {

    const raw = getCookie("CookieConsent");
    if (!raw) return false;

    const validJson = decodeURIComponent(raw).replace(/([a-zA-Z0-9_]+):/g, '"$1":').replace(/'/g, '"');
    const consentData  = JSON.parse(validJson);

    return Boolean(consentData ?.[key]);
    
  } catch (err) {
    console.error("Failed to parse CookieConsent:", err);
    return false;
  }
};
